import { z } from "zod";
export const paymentOptions = [
  { value: "sandbox", label: "Sandbox" },
  { value: "live", label: "Live" },
  // { value: "UPI", label: "UPI" },
  // { value: "Cash", label: "Cash" },
];

export const AppSettingSchema = z.object({
  Free_miles: z.string().min(1, { message: "Free Miles is required" }),
  VEHICLE_WEIGHT_LIMIT_FOR_BIDDING_REQUEST: z
    .string()
    .min(1, { message: "Weight Limit for bidding request is required" }),
  // Per_distance_miles_price: z
  //   .string()
  //   .min(1, { message: "Per distance Miles is required" }),
  Admin_Country: z.string().min(1, { message: "Country is required" }),
  Admin_Email_Address: z
    .string()
    .min(1, { message: "Email is required" })
    .email("Invalid email address"),
  Admin_Currency: z.string().min(1, { message: "Contact Number is required" }),
  Admin_Currency_Code: z
    .string()
    .min(1, { message: "Country currency is required" }),
  Admin_TimeZone: z.object(
    {
      label: z
        .string({ required_error: "Time zone is required" })
        .min(1, { message: "Time zone is required" }),
      value: z
        .string({ required_error: "Time zone is required" })
        .min(1, { message: "Time zone is required" }),
    },
    {
      invalid_type_error: "inValid",
      required_error: "Time zone is required",
    }
  ),
  Admin_Phone_Number: z
    .string()
    .min(1, { message: "Contact NUmber is Required" }),

  Default_Search_Radius: z
    .string()
    .min(1, { message: "radius is required" })
    .refine((data) => !isNaN(data), {
      message: "radius only contain a Numeric value",
    }),
  Agency_Percentage_Commission: z
    .string()
    .min(1, { message: "charges is required" })
    .refine((data) => !isNaN(data), {
      message: "charges only contain a Numeric value",
    }),
  Admin_Percentage_Commission: z
    .string()
    .min(1, { message: "Admin percentage is required" })
    .refine((data) => !isNaN(data), {
      message: "Admin percentage only contain a Numeric value",
    }),
  Driver_Percentage_Commission: z
    .string()
    .min(1, { message: "charges is required" })
    .refine((data) => !isNaN(data), {
      message: "charges only contain a Numeric value",
    }),
  Booking_cancellation_charges: z
    .string()
    .min(1, { message: "charges is required" })
    .refine((data) => !isNaN(data), {
      message: "charges only contain a Numeric value",
    }),
  Android_User_App_Force_Version: z
    .string()
    .min(1, { message: "must contain at least one word" })
    .trim()
    .optional(),
  Android_Driver_App_Force_Version: z
    .string()
    .min(1, { message: "must contain at least one word" })
    .trim()
    .optional(),
  IOS_User_App_Force_Version: z
    .string()
    .min(1, { message: "must contain at least one word" })
    .trim()
    .optional(),
  IOS_Driver_App_Force_Version: z
    .string()
    .min(1, { message: "must contain at least one word" })
    .trim()
    .optional(),
  Payment_Mode: z.nativeEnum(
    paymentOptions.map((i) => i.value),
    {
      required_error: "Payment method is required",
    }
  ),
  // Service_charges: z
  //   .string()
  //   .min(1, { message: "service charges is required" })
  //   .refine((data) => !isNaN(data), {
  //     message: "charges only contain a Numeric value",
  //   }),
  DRIVER_PICKUP_DROPOFF_RADIUS: z
    .string()
    .min(1, { message: "Driver Pickup Dropoff radius is required" }),
  DRIVER_ACCEPT_BOOKING_COUNT: z
    .string()
    .min(1, { message: "Driver Accept Booking Limit is required" }),
});

export const getFormValues = (basicSettingData) => {
  let timeZoneOption = "";

  if (basicSettingData?.time?.timeZoneListing.length) {
    const obj = basicSettingData?.time?.timeZoneListing?.find((item) => {
      return item?.code === basicSettingData?.App_Settings?.Admin_TimeZone;
    });

    timeZoneOption = {
      label: obj.name,
      value: obj.code,
    };
  }

  return {
    Admin_Country: basicSettingData?.App_Settings?.Admin_Country || "",
    Admin_Email_Address:
      basicSettingData?.App_Settings?.Admin_Email_Address || "",
    Admin_Currency: basicSettingData?.App_Settings?.Admin_Currency || "",
    Admin_Currency_Code:
      basicSettingData?.App_Settings?.Admin_Currency_Code || "",
    Admin_TimeZone: timeZoneOption,
    Admin_Phone_Number:
      basicSettingData?.App_Settings?.Admin_Phone_Number || "",
    Default_Search_Radius:
      basicSettingData?.App_Settings?.Default_Search_Radius.toString() || "",
    Agency_Percentage_Commission: basicSettingData?.App_Settings
      ?.Agency_Percentage_Commission
      ? String(basicSettingData?.App_Settings?.Agency_Percentage_Commission)
      : "",
    Admin_Percentage_Commission:
      basicSettingData?.App_Settings?.Admin_Percentage_Commission.toString() ||
      "",

    Driver_Percentage_Commission:
      basicSettingData?.App_Settings?.Driver_Percentage_Commission.toString() ||
      "",

    Booking_cancellation_charges:
      basicSettingData?.App_Settings?.Booking_cancellation_charges.toString() ||
      "",
    Android_User_App_Force_Version:
      basicSettingData?.App_Settings?.Android_User_App_Force_Version || "",
    Android_Driver_App_Force_Version:
      basicSettingData?.App_Settings?.Android_Driver_App_Force_Version || "",
    IOS_User_App_Force_Version:
      basicSettingData?.App_Settings?.IOS_User_App_Force_Version || "",
    IOS_Driver_App_Force_Version:
      basicSettingData?.App_Settings?.IOS_Driver_App_Force_Version || "",
    Payment_Mode: basicSettingData?.App_Settings?.Payment_Mode || "",
    Service_charges:
      basicSettingData?.App_Settings?.Service_charges.toString() || "",
    Free_miles: basicSettingData?.App_Settings?.Free_miles?.toString() || "",
    VEHICLE_WEIGHT_LIMIT_FOR_BIDDING_REQUEST:
      basicSettingData?.App_Settings?.VEHICLE_WEIGHT_LIMIT_FOR_BIDDING_REQUEST?.toString() ||
      "",
    // Per_distance_miles_price:
    //   basicSettingData?.App_Settings?.Per_distance_miles_price || "",
    DRIVER_PICKUP_DROPOFF_RADIUS:
      basicSettingData?.App_Settings?.DRIVER_PICKUP_DROPOFF_RADIUS?.toString() ||
      "",
    DRIVER_ACCEPT_BOOKING_COUNT: basicSettingData?.App_Settings?.DRIVER_ACCEPT_BOOKING_COUNT?.toString() ||
      "",
  };
};
